import { cn } from '@/lib/utils'

interface PageContainerProps {
  /** 자식 요소 */
  children: React.ReactNode
  /** 추가 CSS 클래스 */
  className?: string
  /** 최대 너비 제한 비활성화 */
  noMaxWidth?: boolean
}

/**
 * 페이지 컨테이너 컴포넌트.
 *
 * - 화면 좌우 패딩: 20px
 * - 상하 패딩: 24px
 * - 최대 너비: 480px (모바일 최적화)
 * - 중앙 정렬
 */
export default function PageContainer({
  children,
  className,
  noMaxWidth = false,
}: PageContainerProps) {
  return (
    <main
      className={cn(
        'flex-1 px-[var(--spacing-page-x)] py-[var(--spacing-section)]',
        !noMaxWidth && 'mx-auto w-full max-w-[480px]',
        className
      )}
    >
      {children}
    </main>
  )
}
